<label class="label size--{{ size }}" [ngClass]="labelClass()" [style.font-weight]="weight()">
  <ng-content></ng-content>
  <span class="required-mark" *ngIf="required">*</span>
  <span *ngIf="optional" class="optional">{{ "form-field.optional" | translate }}</span>
</label>
